export const billingCodes = [
    {
        code: "Cancel001",
        label: "Cancellation with Fee",
        investigationType: "All"
    },
    {
        code: "Cancel002",
        label: "Cancellation with no Fee",
        investigationType: "All"
    },
    {
        code: "RUSH",
        label: "Rush Order",
        investigationType: "All"
    },
    {
        code: "OTHER",
        label: "Other",
        investigationType: "All"
    },
    {
        code: "VOID",
        label: "VOID",
        investigationType: "All"
    },
    {
        code: "AS001 (State)",
        label: "Asset Search - Statewide Bank Locate",
        investigationType: "Asset Locate"
    },
    {
        code: "AS001NH",
        label: "Asset Search Statewide Bank Locate Administration Fee",
        investigationType: "Asset Locate"
    },
    {
        code: "AS002 (Nationwide)",
        label: "Asset Search National Bank Locate",
        investigationType: "Asset Locate"
    },
    {
        code: "AS002NH",
        label: "Asset Search - Nationwide Bank Locate Administation Fee",
        investigationType: "Asset Locate"
    },
    {
        code: "AS003 (Nationwide)",
        label: "Asset Search National Brokerage Locate",
        investigationType: "Asset Locate"
    },
    {
        code: "AS003NH",
        label: "Asset Search - Nationwide Brokerage Locate Administation Fee",
        investigationType: "Asset Locate"
    },{
        code: "AS004 (Nationwide)",
        label: "Asset Search National Bank and Brokerage Locate",
        investigationType: "Asset Locate"
    },
    {
        code: "AS004NH",
        label: "Asset Search - Nationwide Bank and Brokerage Locate Administration Fee",
        investigationType: "Asset Locate"
    },
    {
        code: "ASPI",
        label: "Asset Search PI",
        investigationType: "Asset Locate"
    },
    {
        code: "ASPROP",
        label: "Asset Search Locate Property Title/Deed",
        investigationType: "Asset Locate"
    },
    {
        code: "ASR",
        label: "Asset Search Retail",
        investigationType: "Asset Locate"
    },
    {
        code: "ASW",
        label: "Asset Search Wholesale",
        investigationType: "Asset Locate"
    },
    {
        code: "EWL001",
        label: "Employment and Wage Report",
        investigationType: "Asset Locate"
    },
    {
        code: "FEIN",
        label: "Federal Employment Identification Number",
        investigationType: "Asset Locate"
    },
    {
        code: "TS/DP",
        label: "Locate Property - Title Search/Deed Pull",
        investigationType: "Asset Locate"
    },
    {
        code: "IDV",
        label: "ID Verification",
        investigationType: "Background AND/OR Social Media Investigation"
    },
    {
        code: "TCR",
        label: "Traffic Collision Report Retrieval",
        investigationType: "Background AND/OR Social Media Investigation"
    },
    {
        code: "CRP",
        label: "Case Record Pull Civil/Criminal",
        investigationType: "Background AND/OR Social Media Investigation"
    },
    {
        code: "BGR",
        label: "Background Report",
        investigationType: "Background AND/OR Social Media Investigation"
    },
    {
        code: "DMV - OOC",
        label: "Non California - DMV Search",
        investigationType: "DMV"
    },
    {
        code: "DMV001",
        label: "DMV Report",
        investigationType: "DMV"
    },
    {
        code: "DMV002",
        label: "DMV - Photo History",
        investigationType: "DMV"
    },
    {
        code: "DMV003",
        label: "DMV ANI Report",
        investigationType: "DMV"
    },
    {
        code: "DMV004",
        label: "Vehicle Owner History Report",
        investigationType: "DMV"
    },
    {
        code: "LPR",
        label: "License Plate Recognition",
        investigationType: "DMV"
    },
    {
        code: "VDR",
        label: "Vehicle Data Retrieval",
        investigationType: "DMV"
    },
    {
        code: "PL-H001",
        label: "Home/Property Insurance (unknown)",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-H002",
        label: "Home/Property Insurance (known)",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-LC002",
        label: "Locate Insurance Company Only",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-LC002NH",
        label: "Unable to Locate Insurance Carrier - Administrative",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-LCWL001",
        label: "Locate Insurance Carrier w/Limits",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-LCWL001NH",
        label: "Unable to Locate Insurance Carrier and obtain Policy Limits - Administration Fee",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-NOLC001",
        label: "To Locate Insurance Carrier w/Limits and Name Only",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-NOLC002",
        label: "To Locate Insurance Carrier with No address",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-UL001",
        label: "Umbrella Insurance Locate",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-UL001NH",
        label: "Umbrella Insurance Locate Administrative Fee",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL001",
        label: "Auto Insurance Policy Traces(s) Policy Limits",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL002",
        label: "Auto/Umbrella Combo Special",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL003",
        label: "USAA Policy Limits",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL004",
        label: "Policy Limit Seach without Defendants Address",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL005",
        label: "Policy Limit Search w/ DOL 1-3 Years from Today",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-CPL001",
        label: "Commerical Policy Search",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-CPL001NH",
        label: "Unable to  Obtain Commercial Policy Limits with available information  - Administrative Fee",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-NC001",
        label: "No Charge",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-NO001",
        label: "To Obtain Limits With No Address or Date of Birth",
        investigationType: "Insurance Investigation"
    },
    {
        code: "PL-NO001NH",
        label: "Unable to Confirm Coverage w/No Address or DOB - Administrative Fee",
        investigationType: "Insurance Investigation"
    },
    {
        code: "ISO REPORT",
        label: "Claim History",
        investigationType: "Insurance Claim History (ISO)"
    },
    {
        code: "SSN",
        label: "Social Security Number",
        investigationType: "Insurance Claim History (ISO)"
    },
    {
        code: "FIR",
        label: "Field Investigation Report",
        investigationType: "Scene Investigation"
    },
    {
        code: "MILEAGE",
        label: "Mileage",
        investigationType: "Scene Investigation, Subpoena Process Serving, Witness or Defendant Statement"
    },
    {
        code: "SKIP",
        label: "Skip Trace or Locate",
        investigationType: "Skip Trace, DMV, Witness or Defendant Statement, Subpoena Process Serving"
    },
    {
        code: "DOS",
        label: "Deposition Officer Services",
        investigationType: "Subpoena Process Serving"
    },
    {
        code: "DOS- 2+",
        label: "Deposition Officer Services Excess 2",
        investigationType: "Subpoena Process Serving"
    },
    {
        code: "POSTAGE",
        label: "Postage",
        investigationType: "Subpoena Process Serving"
    },
    {
        code: "SOP-EF",
        label: "E-Filing of SOP",
        investigationType: "Subpoena Process Serving"
    },
    {
        code: "SOP-NS",
        label: "Service of Process - Non Standard Service",
        investigationType: "Subpoena Process Serving"
    },
    {
        code: "SOP-RUSH",
        label: "Service of Process Rush",
        investigationType: "Subpoena Process Serving"
    },
    {
        code: "SOP-SDRUSH",
        label: "Service of Process Rush Same Day",
        investigationType: "Subpoena Process Serving"
    },
    {
        code: "SOP-SS",
        label: "Service of Process - Standard Service",
        investigationType: "Subpoena Process Serving"
    },
    {
        code: "SWITRS",
        label: "Statewide Integrated Traffic Records System Report",
        investigationType: "SWITRS"
    },
    {
        code: "WS001",
        label: "Witness Statement",
        investigationType: "Witness or Defendant Statement"
    },
    {
        code: "WS001NH",
        label: "Unable to Obtain Witness Statement - Administrative Fee",
        investigationType: "Witness or Defendant Statement"
    },
    {
        code: "WSTRANS",
        label: "Transcription",
        investigationType: "Witness or Defendant Statement"
    }
];